import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
    FiDataFieldView_DataField,
    FiDataFieldView_DataFieldObject,
    FiDataFieldViewBase,
} from '../data-field-view-base';
import { ContactService } from '@fi-shared/fi-contacts/contact.service';
import { DataFieldModel } from '@fi-app/data-field/data-field.model';

@Component({
    selector: 'data-field-view-email-address',
    templateUrl: './email-address.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiDataFieldViewEmailAddressComponent extends FiDataFieldViewBase {
    constructor(
        @Inject(FiDataFieldView_DataField) dataField: DataFieldModel,
        @Inject(FiDataFieldView_DataFieldObject) dataFieldObject: any,
        public CcmContactService: ContactService,
    ) {
        super(dataField, dataFieldObject);
    }

    get isNotEmpty() {
        return this.dataFieldObject.EmailAddressContacts && this.dataFieldObject.EmailAddressContacts.length > 0;
    }
}
